import { ReactNode } from "react";
import { Stack, Typography } from "@mui/material";

export const ResyncHeaderBlock = ({
  title,
  text,
  icon,
  customText,
  isFirstUpload,
}: {
  title: string;
  text?: string;
  customText?: ReactNode;
  icon: ReactNode;
  isFirstUpload: boolean;
}) => {
  if (!isFirstUpload) return null;

  return (
    <Stack
      sx={{
        gap: "8px",
        padding: "16px",
        alignItems: "flex-start",
        backgroundColor: "custom.surfaceMuted",
        borderRadius: "6px",
      }}
    >
      <Stack flexDirection="row" gap="4px">
        {icon}
        <Typography
          component="span"
          variant="subtitle1"
          color="custom.textDarkBlue"
          fontWeight={500}
        >
          {title}
        </Typography>
      </Stack>
      {text && (
        <Typography component="span" variant="body1" color="text.secondary">
          {text}
        </Typography>
      )}
      {customText}
    </Stack>
  );
};
